import type { Adventure } from '../../types'

// Age 4: Shape Magic - Patterns with Shapes
export const shapeMagicAdventure: Adventure = {
  id: 'shape-magic',
  title: 'Shape Magic Patterns',
  theme: 'patterns',
  targetAge: '4',
  difficulty: 'easy',
  estimatedDuration: 6,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Welcome to shape magic! Shapes can make amazing patterns! Circle, square, circle, square! What comes next?",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at this pattern! Triangle, star, triangle, star... See how it repeats? What shape comes next?",
      duration: 6,
      background: 'shape-world'
    },
    choice1: [
      {
        id: 'continue-shape',
        label: "Continue pattern!",
        tillyLine: "What shape comes next in triangle, star, triangle, star?",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'pattern-complete',
      question: '△ ⭐ △ ⭐ ___',
      tillyPrompt: 'What shape is next?',
      options: [
        { id: 'star', label: '⭐', isCorrect: true },
        { id: 'circle', label: '🔴', isCorrect: false },
        { id: 'square', label: '🟦', isCorrect: false }
      ],
      pattern: ['△', '⭐', '△', '⭐', '___'],
      correctAnswer: '⭐'
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Magical! The star comes next! Now look at this color pattern! Red circle, blue circle, red circle... What is next?",
      duration: 6,
      background: 'shape-world'
    },
    choice2: [
      {
        id: 'color-pattern',
        label: "Find the color!",
        tillyLine: "Red, blue, red, blue... what color circle comes next?",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'pattern-complete',
      question: '🔴 🔵 🔴 🔵 ___',
      tillyPrompt: 'What color comes next?',
      options: [
        { id: 'red', label: '🔴', isCorrect: true },
        { id: 'blue', label: '🔵', isCorrect: false },
        { id: 'yellow', label: '🟡', isCorrect: false }
      ],
      pattern: ['🔴', '🔵', '🔴', '🔵', '___'],
      correctAnswer: '🔴'
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Shape magic master! Big pattern challenge with bigger shapes! Ready?",
        duration: 5,
        background: 'shape-world'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'pattern-complete',
          question: '🔺 🟨 🔺 🟨 🔺 ___',
          tillyPrompt: 'What comes next?',
          options: [
            { id: 'triangle', label: '🔺', isCorrect: false },
            { id: 'square', label: '🟨', isCorrect: true },
            { id: 'circle', label: '🔴', isCorrect: false }
          ],
          pattern: ['🔺', '🟨', '🔺', '🟨', '🔺', '___'],
          correctAnswer: '🟨'
        } as any
      ]
    },
    reward: {
      tillyLine: "Abracadabra! You found all the shape patterns! You are a Shape Magic Master!",
      badgeName: 'Shape Magic Master',
      badgeIcon: '✨',
      nextPreview: 'Next time, we will learn number colors!'
    }
  }
}

export const tillyShapeMagicCorrect = [
  "Magical! You got it!",
  "Shape-tastic! Perfect!",
  "Pattern power! Amazing!",
  "You are a pattern wizard!",
  "Magic touch! Correct!",
  "Abracadabra! Right answer!",
  "Shape sorcery! You did it!",
  "Enchanting work! Great job!",
  "Mystical math skills!",
  "Spellbinding success!"
]

export const tillyShapeMagicWrong = [
  "Almost! Look at the pattern!",
  "Not quite! Try the next shape!",
  "Good try! What comes next?",
  "Close! Check the pattern!",
  "That is okay! Magic takes practice!",
  "Keep trying! You have the magic!",
  "Almost there! One more spell!",
  "Try once more! Magic awaits!",
  "Not yet! Keep the magic alive!",
  "Wand wave! Try again!"
]

export const tillyShapeMagicCelebration = [
  "✨ Magic pattern master! ✨",
  "You cast the perfect spell! 🌟",
  "Shape magic champion! 🏆",
  "Abracadabra! You did it! 🎊",
  "Magical math wizard! 🥇"
]
